import { render, staticRenderFns } from "./CustomerSignup.vue?vue&type=template&id=27bd5931"
import script from "./CustomerSignup.vue?vue&type=script&lang=js"
export * from "./CustomerSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports